<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :return-path="returnPath"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// Author Liang Gangqiang
// Date 2021-08-26 10:24:48

import emCommonEditMixin from "@/mixin/em/common/edit";
import emUtils from "@/utils/emUtils";

export default {
    name: "sithMesQualityInspectTaskEditView",
    mixins: [emCommonEditMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        returnPath() {
            let state = this.$store.state.commonList.customVuexName;
            return "/sithMes/quality/" + (state.lastIndexOf('sithMesQualityInspectTask') !== -1 ? state :
                ('sithMesQualityInspectTask' + emUtils.toCapFirst(state)));
        }
    }
};
</script>